import http from "./http";
const author = {

  myArticleSearch(costed1, costed2, invoice1, status, step) {
    let data = {
      "costed1": costed1,
      "costed2": costed2,
      "invoice1": invoice1,
      "status": status,
      "step": step
    };
    return http.post("author/pay/myAll", data);
  },

  myArticleAdd(model) {
    return http.post("author/myArticle/add", model);
  },

  myArticleRemoveFile(attachId, attachCode) {
    return http.post(
      "author/myArticle/removeFile?attachId=" +
      attachId +
      "&attachCode=" +
      attachCode
    );
  },

  myArticleList(status, order, sort, page, size) {
    return http.get(
      "author/myArticle/list?status=" +
      status +
      "&order=" +
      order +
      "&sort=" +
      sort +
      "&page=" +
      page +
      "&size=" +
      size
    );
  },

  myArticleRuningList(status,step, order, sort, page, size) {
    return http.get(
      "author/myArticle/runList?status=" +
      status +
      "&step="+step+"&order=" +
      order +
      "&sort=" +
      sort +
      "&page=" +
      page +
      "&size=" +
      size
    );
  },

  myArticleRejectedList(page, size) {
    return http.get(
      "author/myArticle/refuseList?page=" +
      page +
      "&size=" +
      size
    );
  },

  myArticleReceiveList(page, size) {
    return http.get(
      "author/myArticle/hireList?page=" +
      page +
      "&size=" +
      size
    );
  },

  getArticleProcessList(articleId) {
    return http.get("author/myArticle/processList?articleId=" + articleId);
  },

  //支付记录
  myPayList(page, size) {
    return http.get(
      "author/pay/record?page=" +
      page +
      "&size=" +
      size
    );
  },


  //修改稿件
  reviseArticle(articleId, attachId, attachCode) {
    var modal = {
      articleId: articleId,
      attachId: attachId,
      attachCode: attachCode
    };
    return http.post("author/upload/editedArticle", modal);
  },


  //付款
  pay(articleId, payAmount, payType, type) {
    var modal = {
      articleId: articleId,
      payAmount: payAmount,
      payType: payType,
      type: type
    };
    return http.post("author/order/pay", modal);
  },

  //获取支付付款二维码
  getPayQcUrl(articleId) {
    return http.post("author/order/getQcUrl?articleId=" + articleId, {});
  },

  //刷新付款二维码
  refreshPayQcUrl(articleId) {
    return http.post("author/order/upload?articleId=" + articleId, {});
  },

  //刷新支付状态
  refreshPayStatus(articleId) {
    return http.post("author/order/uprecord?articleId=" + articleId, {});
  },

  //检测支付是否成功
  getPayResult(orderId) {
    return http.post("author/pay/orderOne?orderId=" + orderId, {});
  },

  //主动撤稿
  revokeArticle(articleId, type) {
    return http.post('author/Article/ArticleReject?articleId=' + articleId + '&type=' + type)
  },

  //提交著作权证书表单
  postLicense(articleId, attachId, attachCode) {
    var modal = {articleId,attachId,attachCode};
    return http.post("author/upload/editedCopyright", modal);
  },

};
export default author;
